import Tile from './Tile'

import {Col, Flex} from '@amzn/stencil-react-components/layout'
import {Text} from '@amzn/stencil-react-components/text'
import {WithBreakpoints} from '@amzn/stencil-react-components/responsive'
import {Chip, ChipSize, ChipBackgroundColor} from '@amzn/stencil-react-components/chip';
import {MOCK_ID} from "../../../../utils/testConstants";

class VestTile extends Tile {

  constructor(props) {
    super(props);
  }

  renderHeaderBadge(label) {
    return (
      <Chip dataTestId="VestTile_label" size={ChipSize.ExtraSmall} backgroundColor={ChipBackgroundColor.Blue}>{label}</Chip>
    );
  }

  renderHeader(date, badgeLabel) {
    return (
      <WithBreakpoints>
        {({ matches }) => (
          <Flex
            justifyContent="space-between"
            minHeight={20}
            rowGap="S100"
            flexDirection={matches.s ? "column" : "row"}
          >
            <Col dataTestId="VestTile_date" >
              <Text color="neutral70" textAlign='left'>{date}</Text>
            </Col>
            {badgeLabel && this.renderHeaderBadge(badgeLabel)}
          </Flex>
        )}
      </WithBreakpoints>
    );
  }

  renderInfo(info) {
    return (
      <Text dataTestId="VestTile_footer_info" fontSize="T400" fontWeight="bold" textAlign='left'>{info}</Text>
    );
  }

  renderFooter(footerTop, footerMid, footerMidLabel, footerBottom, footerBottomLabel, info) {
    return (
      <Col flexWrap="wrap">
        {this.renderInfo(info)}
        <Col dataTestId="VestTile_footer_col_1">
          <Text color="neutral70" textAlign='left'>{footerTop}</Text>
        </Col>
        <Col dataTestId="VestTile_footer_col_2">
          <Text color="neutral70" textAlign='left'>{footerMid}{footerBottom && footerMidLabel}</Text>
        </Col>
        <Col dataTestId="VestTile_footer_col_3">
          <Text color="neutral70" textAlign='left'>{footerBottom}{footerBottom && footerBottomLabel}</Text>
        </Col>
      </Col>
    );
  }

  renderCardContent() {
    return (
      <WithBreakpoints>
        {({ matches }) => (
          <>
          {matches.s &&
            <Col dataTestId="VestTile_s" gridGap="S200">
              {this.renderHeader(this.props.date, this.props.headerBadgeLabel)}
              {this.renderFooter(this.props.footerTop, this.props.footerMid,
                this.props.footerMidLabel, this.props.footerBottom, this.props.footerBottomLabel, this.props.info)}
            </Col>
          }
          {!matches.s &&
            <Col dataTestId={MOCK_ID.VEST_TILE_L} width="435px" gridGap="S200">
              {this.renderHeader(this.props.date, this.props.headerBadgeLabel)}
              {this.renderFooter(this.props.footerTop, this.props.footerMid,
                this.props.footerMidLabel, this.props.footerBottom, this.props.footerBottomLabel, this.props.info)}
            </Col>
          }
          </>
        )}
      </WithBreakpoints>
    )
  }

  render() {
    return super.renderTile(this.props.isClickable);
  }
}

export default VestTile
